export default __webpack_public_path__ + "static/media/Directory.98183196.svg";